import { createSelector } from 'reselect'
import { getSearchIsReturn } from 'tickets/redux/modules/searchParams/selectors'
import {
  getSelectedOutboundItineraryId,
  getSelectedInboundItineraryId,
  getCurrentModeId,
} from 'tickets/redux/modules/router/selectors'


// todo need to depericate all of reference of inbound/outbound mode id
// currently just forwarding on inbound/outbound modeID's to the active modeID
const getSelectedOutboundModeId = createSelector(
  [getCurrentModeId],
  (currentModeId) => currentModeId
)

const getSelectedInboundModeId = createSelector(
  [getCurrentModeId],
  (currentModeId) => currentModeId
)

const getSelectedOutboundFareClassNames = (state) => state.selections.outbound.fareClasses
const getSelectedInboundFareClassNames = (state) => state.selections.inbound.fareClasses

const getHasSelectedOutboundItinerary = createSelector(
  [getSelectedOutboundItineraryId],
  (outboundItineraryId) => outboundItineraryId != null || outboundItineraryId != undefined
)

const getHasSelectedInboundItinerary = createSelector(
  [getSelectedInboundItineraryId],
  (inboundItineraryId) => inboundItineraryId != null || inboundItineraryId != undefined
)

const getIsSelectingInbound = createSelector(
  [getSearchIsReturn, getHasSelectedOutboundItinerary],
  (isReturnSearch, hasSelectedOutboundItinerary) => isReturnSearch && hasSelectedOutboundItinerary
)

export {
  getSelectedOutboundModeId,
  getSelectedInboundModeId,
  getSelectedOutboundFareClassNames,
  getSelectedInboundFareClassNames,
  getHasSelectedOutboundItinerary,
  getHasSelectedInboundItinerary,
  getIsSelectingInbound,
}
